import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { registerField } from 'core/forms';

import { Typo } from 'uikit/content';

import styles from '../styles/formFieldDivider.module.scss';

const FormFieldDivider = ({ schema }) => (
  <div className={classNames(styles.divider, schema.className)}>
    <Typo variant={schema.variant || 'd01'} element={schema.element || 'span'}>
      {schema.text}
    </Typo>
  </div>
);

FormFieldDivider.propTypes = {
  schema: PropTypes.shape({
    className: PropTypes.string,
    element: PropTypes.oneOf([
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'p',
      'span',
      'div',
    ]),
    variant: PropTypes.oneOf([
      'h1',
      'd07',
      'h2',
      'd06',
      'h3',
      'd05',
      'h4',
      'd04',
      'd03',
      'd02',
      'h5',
      'd01',
      'b03',
      'h6',
      'p',
      'span',
      'b02',
      'b01',
      's03',
      's02',
      's01',
      'c01',
    ]),
    text: PropTypes.string.isRequired,
  }).isRequired,
};

registerField('Divider', memo(FormFieldDivider));
